import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {  
  Modal,
  Card,
  Button,
  Header,
  Label,
  Icon,  
  Form,
  Confirm,
  Message
} from 'semantic-ui-react';
import { ldapActions } from '../../actions/ldap.actions';
import PropTypes from 'prop-types';
import { history } from '../../helpers';
import { userConstants } from '../../constants/user.constants';
import moment from 'moment';

class LdapIndexScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
        ldapServerstatus: 'open',
        ldapServers: null,
        confirmOpen: false,
        confirmAction: null,
        confirmLdapServer: null,
        confirmMessage: null,
        testCredentials: {},
        testLdapServer: null,
        testError: null,
        testSuccess: null,
        me: null
    };
  }

  static get propTypes() { 
    return { 
        ldapServerstatus: PropTypes.string,
        ldapServers: PropTypes.any,
        confirmOpen: PropTypes.bool,
        confirmAction: PropTypes.string,
        confirmMessage: PropTypes.string,
        confirmLdapServer: PropTypes.any,
        me: PropTypes.any,
        loading: PropTypes.bool
    }; 
  }

  componentDidMount() { 
    this.setState({testResult : null});
    this.fetchServers();
  }

  fetchServers() {
    const { dispatch } = this.props;         
    dispatch(ldapActions.fetch());
  }

  showConfirm(ldapServer, action) {
    const msg =  `Tem certeza que deseja remover o servidor #${ldapServer.Host}?`;
    this.setState({
      confirmOpen: true,
      confirmAction: action,
      confirmLdapServer
      : ldapServer,
      confirmMessage: msg
    });
  }

  closeConfirm() {
    this.setState({ confirmOpen: false});
  }

  executeConfirm() {
    const { dispatch } = this.props;
    const { confirmLdapServer
      , confirmAction } = this.state;
    if (confirmAction == 'remove') {
      dispatch(ldapActions.remove(confirmLdapServer.Id)).then(() => this.fetchServers());
    }

    setTimeout(() => this.fetchldapServers(), 1000);

    this.setState({
      confirmOpen: false,
      confirmAction: null,
      confirmLdapServer: null,
      confirmMessage: null
    });
  }

  handleChange(field, data) {        
    const { testCredentials } = this.state;    
    testCredentials[field] = data;    
    this.setState({ testCredentials });    
  }

  testAuth(ldapServer) {
    const { dispatch } = this.props;
    this.setState({testResult : null});
    dispatch(ldapActions.test(ldapServer.Id, this.state.testCredentials));    
  }

  goToCreate() {
    history.push('/ldap/create');
  }

  render() {    
    const { ldapServers, testResult, loading, me } = this.props;
    // Check Permission    
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }
    
    return (
      <Fragment>
        <Confirm open={this.state.confirmOpen} content={this.state.confirmMessage} onCancel={() => this.closeConfirm()} onConfirm={() => this.executeConfirm()} />
        <Header>
          <h1>Servidores Autenticação</h1>   
        </Header>
        <div style={{textAlign:"right", marginBottom: "8px"}}>
          <Button primary onClick={this.goToCreate}>Novo Servidor</Button>
        </div>
        <Card.Group>
          { (!ldapServers || (ldapServers.Results && ldapServers.TotalNumberOfRecords == 0)) &&
            <Card header='Nenhum servidor' fluid />
          }

          { ldapServers && ldapServers.Results && ldapServers.Results.map((ldapServer) => {           
            return <Card key={ldapServer.Id} fluid>
              <Card.Content>
                <Card.Header>
                  {ldapServer.Host}
                  <Label style={{float: "right"}} color={ldapServer.Enabled ? 'green' : 'red'}>
                    {ldapServer.Enabled ? 'Ativo' : 'Inativo'}
                  </Label>
                </Card.Header>
                <Card.Description>
                  <p><strong>Tipo:</strong> {ldapServer.Type == 1 ? 'LDAP' : 'Active Directory'}</p>                  
                  <p><strong>Domínio:</strong> {ldapServer.Domain}</p>                  
                  <p><strong>Filtro:</strong> {ldapServer.Filter}</p>                  
                  <p><strong>Usuário:</strong> {ldapServer.Username}</p>                  
                </Card.Description>  
              </Card.Content>              
              <Card.Content extra>   
                  <Modal trigger={<Button color='blue' size='mini'>Testar Autenticação</Button>}>
                    <Modal.Header>Teste de Servidor de Autenticação</Modal.Header>
                    <Modal.Content image>                      
                      <Modal.Description>      
                        <Form>    
                          <h4><strong>Servidor</strong> {ldapServer.Host}:{ldapServer.Port}</h4>
                          <h5>
                            <strong>Tipo</strong> {ldapServer.Type == 1 ? 'LDAP' : 'Active Directory'}&nbsp;&nbsp;
                            <strong>BaseDN</strong> {ldapServer.Domain}&nbsp;&nbsp;
                            <strong>Filtro</strong> {ldapServer.Filter}
                          </h5>

                          <Form.Input label='Usuário' name='username' type='text' onChange={(e, data) => this.handleChange("username", data.value)} />        
                          <Form.Input label='Senha' name='password' type='password' onChange={(e, data) => this.handleChange("password", data.value)} />        
                          <Button primary type='submit' loading={loading} onClick={() => this.testAuth(ldapServer)}>Testar</Button>
                          {testResult && <Message color={testResult.error ? 'red' : 'green'}>{testResult.message}</Message>}                        
                        </Form>
                      </Modal.Description>
                    </Modal.Content>
                  </Modal>             

                  <Button size='mini' secondary icon onClick={() => history.push(`/ldap/update/${ldapServer.Id}`) }>
                    <Icon name='edit' />
                    Alterar
                  </Button>

                  <Button size='mini' color='red' icon onClick={() => this.showConfirm(ldapServer, 'remove') }>
                    <Icon name='trash' />
                    Excluir
                  </Button>                  
              </Card.Content>          
            </Card>                      
          }) }
        </Card.Group>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { ldapServers, users } = state;      
  return { 
    ldapServers,
    loading: ldapServers.loading,
    testResult: ldapServers.testResult,
    me: users.me || null
  };
}

const connectedLdapIndexScreen = connect(mapStateToProps)(LdapIndexScreen);
export { connectedLdapIndexScreen as LdapIndexScreen };
